import { atom } from "jotai";

export const showDataSourcesAtom = atom<boolean>(false);
